import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import GlassCard from "./GlassCard";

export default function EducationStart(props) {
  return (
    <GlassCard
      sx={{
        mb: 1,
        padding: "16px 20px",
        borderColor: "rgba(255,131,168,0.85)",
      }}
    >
      <Box sx={{ display: "flex", flexDirection: "column" }}>
        <Box>
          <Typography
            component="div"
            variant="h6"
            color="primary"
            sx={{ fontFamily: "Roboto", fontWeight: 500 }}
          >
            <span style={{ color: "#FF83A8", fontWeight: 600 }}>
              University of Edinburgh
            </span>
            {" | Enrolled"}
          </Typography>
        </Box>
        <Box sx={{ mt: 0.25 }}>
          <Typography
            component="div"
            variant="body2"
            sx={{
              fontFamily: "RobotoLight",
              fontWeight: 300,
              color: "rgba(255,255,255,0.85)",
              fontSize: "0.78rem",
            }}
          >
            2016 · Edinburgh, Scotland
          </Typography>
        </Box>
      </Box>
    </GlassCard>
  );
}
